import { SVGProps } from 'react';

interface SearchIconProps extends SVGProps<SVGSVGElement> {
  opacity?: number;
}
export function SearchIcon({ opacity = 1, ...props }: SearchIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4.875 11C4.875 7.61726 7.61726 4.875 11 4.875C14.3827 4.875 17.125 7.61726 17.125 11C17.125 14.3827 14.3827 17.125 11 17.125C9.31612 17.125 7.79238 16.4467 6.68426 15.3463C5.56589 14.2357 4.875 12.6994 4.875 11ZM11 3.125C6.65076 3.125 3.125 6.65076 3.125 11C3.125 13.1844 4.01552 15.1624 5.45116 16.588C6.87374 18.0007 8.83562 18.875 11 18.875C12.6858 18.875 14.248 18.3453 15.529 17.4432L18.7929 20.7071C19.1834 21.0976 19.8166 21.0976 20.2071 20.7071C20.5976 20.3166 20.5976 19.6834 20.2071 19.2929L17.0069 16.0927C18.1721 14.7196 18.875 12.9419 18.875 11C18.875 6.65076 15.3492 3.125 11 3.125Z" />
    </svg>
  );
}
